const common = {
  "site.name": "韩漫之家",
  "site.slogan": "好看韩国漫画_韩漫在线_无删减下拉式韩漫免费阅读",
  "site.description": "在韩漫之家发现精彩好看韩国漫画，享受韩漫在线无删减下拉式免费阅读，提供完整而可靠的阅读服务。",
  "nav.home": "首页",
  "nav.category": "分类",
  "nav.ranking": "排行榜",
  "nav.about": "关于我们",
  "nav.latest": "最新更新",
  "breadcrumb.home": "首页",
  "breadcrumb.category": "分类",
  "breadcrumb.about": "关于我们",
  "footer.copyright": "© 2026 韩漫之家 版权所有",
  "footer.disclaimer": "本站所有漫画均来自互联网，仅供学习交流使用，请支持正版。",
  "hero.title": "发现精彩韩漫世界",
  "hero.subtitle": "海量热门韩漫，无删减下拉式免费阅读，随时随地享受阅读乐趣",
  "hero.cta": "开始阅读",
  "hero.search": "搜索你喜欢的漫画...",
  "section.featured": "热门推荐",
  "section.latest": "最新更新",
  "section.ranking": "人气排行",
  "section.category": "漫画分类",
  "comic.status.ongoing": "连载中",
  "comic.status.completed": "已完结",
  "comic.chapters": "章节列表",
  "comic.read": "开始阅读",
  "comic.author": "作者",
  "comic.views": "阅读量",
  "comic.rating": "评分",
  "comic.tags": "标签",
  "comic.related": "相关推荐",
  "about.title": "关于韩漫之家",
  "about.intro": "品牌介绍",
  "about.reputation": "平台口碑",
  "about.contact": "联系我们",
  "about.stats.comics": "收录漫画",
  "about.stats.users": "活跃读者",
  "about.stats.chapters": "更新章节",
  "about.stats.years": "运营年限",
  "category.all": "全部",
};

export default common;